import $ from 'jquery';

export function initMenu() {

  $("header .btn-menu").on('click', function(e) {
    e.preventDefault();
    var $submenu = $("#sub-menu");
    var $this = $(this);
    $submenu.toggleClass("open");
    $("body .wrapper, header .btn-menu").toggleClass("menu-open");
    $("body").toggleClass("modal-open");
  });

  $(".menu-overlay").on('click', function(e) {
    $("header .btn-menu").trigger('click');
  });


}
